import { css, keyframes } from "@emotion/css";
import { minScreen } from "utils/mediaQueries";
import { Color } from "utils/variables";

export const body = css`
  width: 160px;
  height: 120px;
  position: relative;
  background: #0d0d0d;
  ${minScreen("md")} {
    width: 210px;
  }
`;
export const bodyExpand = css`
  width: 220px;
  height: 150px;
  position: absolute;
  bottom: 86px;
  right: 10px;
  border: 3px solid ${Color.White};
  border-radius: 14px;
  box-sizing: border-box;
  transition: border-color 0.5s;
  ${minScreen("md")} {
    width: 300px;
    height: 204px;
  }
`;
export const bodyExtendBack = css`
  width: 100%;
  height: 100%;
  bottom: 0;
  right: 0;
  border: none;
  border-radius: 0;
  video {
    border-radius: 0;
  }
`;

export const uiWrap = css`
  width: 100%;
  height: 100%;
  padding: 15px 0;
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const uiWrapExpand = css`
  ${uiWrap};
  z-index: 0;
`;

export const audio = css`
  opacity: 0;
`;

export const video = css`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  object-fit: cover;
`;
export const videoExpand = css`
  border-radius: 10px;
  z-index: 1;
`;

export const text = css`
  margin: 0;
  color: ${Color.White};
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;

export const flexWrap = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const statusCheck = css`
  margin: 0;
  position: absolute;
  top: 2px;
  left: 2px;
  color: ${Color.White};
  font-size: 9px;
`;

export const dots = css`
  height: 10px;
  margin-top: 20px;
`;
const wave = keyframes`
  0% {
    transform: scale(0)
  }
  50% {
    transform: scale(1)
  }
  100% {
    transform: scale(0)
  }
`;
export const dot = css`
  width: 10px;
  height: 10px;
  margin: 0 3px;
  background: ${Color.PaleGreen};
  border-radius: 20px;
  animation: ${wave} 1s ease backwards infinite;
  &:first-child {
    animation-delay: 0s;
  }
  &:nth-child(2) {
    animation-delay: 0.1s;
  }
  &:nth-child(3) {
    animation-delay: 0.2s;
  }
  &:nth-child(4) {
    animation-delay: 0.3s;
  }
  &:nth-child(5) {
    animation-delay: 0.4s;
  }
  &:nth-child(6) {
    animation-delay: 0.5s;
  }
`;

export const operatorName = css`
  margin: 0;
  position: absolute;
  bottom: 15px;
  left: 10px;
  color: ${Color.White};
  font-size: 9px;
  line-height: 9px;
`;

export const cameraoff = css`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 20;
  top: 0;
  background: #0d0d0d;
  border-radius: 0 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  line-height: 1;
`;
export const cameraoffExpand = css`
  border-radius: 0;
  z-index: 2;
`;
export const cameraoffExtendFront = css`
  border-radius: 10px 10px 10px 10px;
`;

export const avatorWrap = css`
  width: 68px;
  height: 68px;
  background: ${Color.White};
  border: 4px solid ${Color.White};
  border-radius: 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.5s;
`;
export const avatorWrapExpand = css`
  width: 102px !important;
  height: 102px !important;
`;
export const avatorWrapNoBorder = css`
  width: 68px !important;
  height: 68px !important;
  border: none !important;
`;
export const avator = css`
  fill: #f8a902;
`;
export const avatorName = css`
  margin: 0;
  color: ${Color.White};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`;
